var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#3B82F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0827 9.33594H13.916L11.8327 11.8359H9.33268C8.89065 11.8359 8.46673 12.0115 8.15417 12.3241C7.84161 12.6367 7.66602 13.0606 7.66602 13.5026V21.0026C7.66602 21.4446 7.84161 21.8686 8.15417 22.1811C8.46673 22.4937 8.89065 22.6693 9.33268 22.6693H22.666C23.108 22.6693 23.532 22.4937 23.8445 22.1811C24.1571 21.8686 24.3327 21.4446 24.3327 21.0026V13.5026C24.3327 13.0606 24.1571 12.6367 23.8445 12.3241C23.532 12.0115 23.108 11.8359 22.666 11.8359H20.166L18.0827 9.33594Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.3359C17.3807 19.3359 18.5 18.2166 18.5 16.8359C18.5 15.4552 17.3807 14.3359 16 14.3359C14.6193 14.3359 13.5 15.4552 13.5 16.8359C13.5 18.2166 14.6193 19.3359 16 19.3359Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraicon);
export default __webpack_public_path__ + "static/media/camera icon.d4abd2e8cf9b5167414b2aa8df17e658.svg";
export { ForwardRef as ReactComponent };